import React, {useEffect, useState} from 'react'
import './orderList.css'
import 'react-toastify/dist/ReactToastify.css'
import {apiConstants, postGeneric} from '../../../common/constants'
import {
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  Chip,
  Box,
} from '@mui/material'
import ProzoDataGrid, {lastPageRowCount} from '../../../common/ProzoDataGrid'
import {getMerchant} from '../../../helpers/ReduxHelpers'
import {useForm} from 'react-hook-form'
import MUIModal from '../../../common/MUIModal'
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary'
import SmsFailedIcon from '@mui/icons-material/SmsFailed'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import UploadIcon from '@mui/icons-material/Upload'
import Loader from '../../../common/Loader'
import UpdateStatus from './UpdateStatus'
import UploadImage from './UploadImage'
import StatusLog from './StatusLog'
import ViewImages from './ViewImages'
import _ from 'lodash'
import {useSnackbar} from 'notistack'
import {convertDate, formatCurrency, formatDate} from '../../../helpers/UtilityHelper'
import AwbLinkCell from '../../../common/AwbLinkCell'
import {
  FormProvider,
  RHFDateRangePickerField,
  RHFSelectField,
  RHFTextField,
} from '../../../common/hook-form'
import {useGetCouriersQuery} from '../../../redux/commonRTKPersist'
import {useNavigate} from 'react-router-dom'
import {FileDownloadOutlined} from '@mui/icons-material'
import {filterBarSx, primaryBtnSx, secondaryBtnSx} from '../../../styles/patterns'
import {primaryTextSx, secondaryTextSx, cellStackSx} from '../../orders/list2/cellStyles'

const WD_STATUS_COLORS = {
  NEW: '#1976d2',
  ACCEPTED_BY_MERCHANT: '#2e7d32',
  ACCEPTED_BY_COURIER: '#2e7d32',
  AUTO_ACCEPTED_BY_SYSTEM: '#2e7d32',
  DISPUTED_BY_MERCHANT: '#d32f2f',
  DISPUTED_BY_COURIER: '#d32f2f',
  REJECTED_PROSHIP: '#d32f2f',
  ACCEPTED_PROSHIP: '#2e7d32',
}

const wdChipSx = (status) => {
  const color = WD_STATUS_COLORS[status] || '#757575'
  return {
    fontWeight: 600,
    fontSize: 11,
    height: 24,
    bgcolor: color + '18',
    color,
    border: `1px solid ${color}40`,
    '& .MuiChip-label': {px: 1},
  }
}

const WeightDiscrepancyDetails = () => {
  const methods = useForm({
    defaultValues: {
      status: '',
      merchant: '',
      awb: '',
    },
  })
  const {handleSubmit, reset, setValue, watch} = methods
  const merchant = getMerchant()
  const merchantId = merchant.id ? merchant.id : ''
  const statusValue = watch('status')

  const {enqueueSnackbar} = useSnackbar()
  const [list, setList] = useState([])
  const [page, setPage] = useState(0)
  const [sizePerPage, setSizePerPage] = useState(10)
  const [open, setOpen] = useState(false)
  const [awb, setAwb] = useState()
  const [Status, setStatus] = useState()
  const [dispute, setDispute] = useState(false)
  const [agree, setAgree] = useState(false)
  const [log, setLog] = useState(false)
  const [loading, setLoading] = useState(false)
  const [reload, setReload] = useState(0)
  const [filters, setFilters] = useState({})
  const [count, setCount] = useState({})
  const [viewImagesModal, setViewImagesModal] = useState(false)
  const [selectedImages, setSelectedImages] = useState([])
  const status = [
    {label: 'All', value: 'All'},
    {label: 'New', value: 'NEW'},
    {label: 'DISPUTED BY COURIER', value: 'DISPUTED_BY_COURIER'},
    {label: 'DISPUTED BY MERCHANT', value: 'DISPUTED_BY_MERCHANT'},
    {label: 'ACCEPTED BY COURIER', value: 'ACCEPTED_BY_COURIER'},
    {label: 'ACCEPTED BY MERCHANT', value: 'ACCEPTED_BY_MERCHANT'},
    {label: 'REJECTED PROSHIP', value: 'REJECTED_PROSHIP'},
    {label: 'ACCEPTED PROSHIP', value: 'ACCEPTED_PROSHIP'},
    {label: 'AUTO ACCEPTED BY SYSTEM', value: 'AUTO_ACCEPTED_BY_SYSTEM'},
  ]

  const {data: allCouriers} = useGetCouriersQuery()
  const navigate = useNavigate()

  const onSubmit = (data) => {
    setFilters({
      statusIn: data.status,
      awbNumber: data.awb,
      createdDateLT: data.toDate ? convertDate(data.toDate) : '',
      createdDateGT: data.fromDate ? convertDate(data.fromDate) : '',
    })
    setCount({
      merchantId: data.merchant,
      statusIn: data.status,
      awbNumber: data.awb,
      createdDateLT: data.toDate ? convertDate(data.toDate) : '',
      createdDateGT: data.fromDate ? convertDate(data.fromDate) : '',
    })
  }

  useEffect(() => {
    setLoading(true)
    filters.merchantId = merchantId
    filters.skip = page * sizePerPage
    filters.limit = sizePerPage
    filters.countOnly = true
    if (filters.statusIn === 'All') {
      filters.statusIn = ''
    } else if (!filters.statusIn && filters.statusIn !== '') {
      setValue('status', 'NEW')
      filters.statusIn = 'NEW'
    }
    postGeneric(apiConstants.GET_WEIGHT_DICREPENACY, filters)
      .then((res) => {
        setLoading(false)
        setList(res?.data?.responseObj)
      })
      .catch((err) => {
        setLoading(false)
        console.log('err', err)
      })
  }, [filters, reload, sizePerPage, page, merchantId, setValue])

  const columns = [
    {
      field: 'shippingdetails',
      headerAlign: 'center',
      hideSortIcons: true,
      align: 'center',
      headerName: 'Shipment Details',
      width: 200,
      minWidth: 200,
      renderCell: (params) => {
        const {row} = params
        const courier = allCouriers?.filter((item) => item.prozoId === row?.couriorProvider)
        return (
          <Box sx={cellStackSx}>
            <AwbLinkCell awb={row?.awbNumber} sx={primaryTextSx} />
            <Typography sx={secondaryTextSx}>{courier?.[0]?.parent}</Typography>
          </Box>
        )
      },
    },
    {
      field: 'current_tatus',
      headerAlign: 'center',
      hideSortIcons: true,
      align: 'center',
      headerName: 'Current Status',
      width: 200,
      minWidth: 180,
      renderCell: (params) => {
        const {row} = params
        let text = row.status
        switch (row.status) {
          case 'NEW':
            text = 'New'
            break
          case 'ACCEPTED_BY_MERCHANT':
            text = 'Accepted By Merchant'
            break
          case 'ACCEPTED_BY_COURIER':
            text = 'Accepted By Courier'
            break
          case 'DISPUTED_BY_COURIER':
            text = 'Disputed By Courier'
            break
          case 'DISPUTED_BY_MERCHANT':
            text = 'Disputed By Merchant'
            break
          case 'AUTO_ACCEPTED_BY_SYSTEM':
            text = 'System Accepted'
            break
          default:
            text = row.status
        }
        return (
          <Box sx={cellStackSx}>
            <Chip size='small' sx={wdChipSx(row.status)} label={text} />
          </Box>
        )
      },
    },
    {
      field: 'last_status',
      headerAlign: 'center',
      hideSortIcons: true,
      align: 'center',
      headerName: 'Last Update',
      width: 150,
      minWidth: 130,
      renderCell: (params) => {
        const {row} = params
        const length = row?.statusLog.length
        return (
          <Box sx={cellStackSx}>
            <Typography sx={secondaryTextSx}>{formatDate(row?.statusLog[length - 1]?.date)}</Typography>
          </Box>
        )
      },
    },
    {
      field: 'originalweight',
      headerAlign: 'center',
      hideSortIcons: true,
      align: 'center',
      headerName: 'Original Weight',
      width: 150,
      minWidth: 150,
      renderCell: (params) => {
        const {row} = params
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{(row?.originalWeight / 1000).toFixed(2)} kg</Typography>
            <Typography sx={secondaryTextSx}>{row?.originalAmount ? formatCurrency(row?.originalAmount) : 'NA'}</Typography>
            <Typography sx={{...secondaryTextSx, fontSize: 11}}>
              Slab: {row?.weightSlabsMerchant ? (row?.weightSlabsMerchant?.originalSlab?.startWeight / 1000).toFixed(2) : 'NA'} - {row?.weightSlabsMerchant ? (row?.weightSlabsMerchant?.originalSlab?.endWeight / 1000).toFixed(2) : 'NA'} kg
            </Typography>
          </Box>
        )
      },
    },
    {
      field: 'appliedweight',
      headerAlign: 'center',
      hideSortIcons: true,
      align: 'center',
      headerName: 'Applied Weight',
      width: 150,
      minWidth: 150,
      renderCell: (params) => {
        const {row} = params
        return (
          <Box sx={cellStackSx}>
            <Typography sx={{...primaryTextSx, color: '#d32f2f'}}>{(row?.finalChargedWeight / 1000).toFixed(2)} kg</Typography>
            <Typography sx={{...secondaryTextSx, color: '#d32f2f'}}>{row?.finalAmountCharged ? formatCurrency(row?.finalAmountCharged) : 'NA'}</Typography>
            <Typography sx={{...secondaryTextSx, fontSize: 11}}>
              Slab: {row?.weightSlabsMerchant ? (row?.weightSlabsMerchant?.finalAppliedSlab?.startWeight / 1000).toFixed(2) : 'NA'} - {row?.weightSlabsMerchant ? (row?.weightSlabsMerchant?.finalAppliedSlab?.endWeight / 1000).toFixed(2) : 'NA'} kg
            </Typography>
          </Box>
        )
      },
    },
    {
      field: 'createdDate',
      headerAlign: 'center',
      hideSortIcons: true,
      align: 'center',
      headerName: 'Created Date',
      width: 150,
      minWidth: 130,
      renderCell: (params) => {
        const {row} = params
        return (
          <Box sx={cellStackSx}>
            <Typography sx={secondaryTextSx}>{formatDate(row?.createdDate)}</Typography>
          </Box>
        )
      },
    },
    {
      field: 'courierImages',
      headerAlign: 'center',
      align: 'center',
      hideSortIcons: true,
      headerName: 'Courier Images',
      width: 150,
      minWidth: 120,
      renderCell: (params) => {
        const {row} = params
        if (row?.courierImagesS3Link) {
          return (
            <Box sx={cellStackSx}>
              <Button
                variant='text'
                size='small'
                onClick={() => {
                  setSelectedImages(row.courierImagesS3Link)
                  setViewImagesModal(true)
                }}
                sx={{fontSize: '12px', textTransform: 'none', p: 0, minWidth: 'auto'}}
              >
                View ({row.courierImagesS3Link?.length})
              </Button>
            </Box>
          )
        } else {
          return '-'
        }
      },
    },
    {
      field: 'merchantImages',
      headerAlign: 'center',
      align: 'center',
      hideSortIcons: true,
      headerName: 'Merchant Images',
      width: 150,
      minWidth: 120,
      renderCell: (params) => {
        const {row} = params
        if (row?.merchantImagesS3Link) {
          return (
            <Box sx={cellStackSx}>
              <Button
                variant='text'
                size='small'
                onClick={() => {
                  setSelectedImages(row.merchantImagesS3Link)
                  setViewImagesModal(true)
                }}
                sx={{fontSize: '12px', textTransform: 'none', p: 0, minWidth: 'auto'}}
              >
                View ({row.merchantImagesS3Link?.length})
              </Button>
            </Box>
          )
        } else {
          return '-'
        }
      },
    },
    {
      field: 'action',
      headerAlign: 'center',
      align: 'center',
      hideSortIcons: true,
      headerName: 'Action',
      width: 200,
      minWidth: 160,
      renderCell: (params) => {
        const {row} = params
        const list = ['AUTO_ACCEPTED_BY_SYSTEM', 'ACCEPTED_BY_MERCHANT', 'ACCEPTED_BY_COURIER']
        const verified = _.intersection(list, [row?.status])
        if (verified?.length > 0) {
          return (
            <Box sx={{display: 'flex', gap: 0.5, alignItems: 'center'}}>
              <Tooltip title='Status Log'>
                <IconButton size='small' varient='contained' onClick={() => handleOpenstatus(row)}>
                  <LocalLibraryIcon fontSize='small' />
                </IconButton>
              </Tooltip>
              <Tooltip title='Upload Image'>
                <IconButton color='info' size='small' onClick={() => handleOpen(row?.awbNumber)}>
                  <UploadIcon fontSize='small' />
                </IconButton>
              </Tooltip>
            </Box>
          )
        } else if (row?.status === 'DISPUTED_BY_MERCHANT') {
          return (
            <Box sx={{display: 'flex', gap: 0.5, alignItems: 'center'}}>
              <Tooltip title='Status Log'>
                <IconButton size='small' varient='contained' onClick={() => handleOpenstatus(row)}>
                  <LocalLibraryIcon fontSize='small' />
                </IconButton>
              </Tooltip>
              <Tooltip title='Accept'>
                <IconButton
                  color='success'
                  size='small'
                  onClick={() => handleOpenAgree(row?.awbNumber)}
                >
                  <CheckCircleIcon fontSize='small' />
                </IconButton>
              </Tooltip>
              <Tooltip title='Upload Image'>
                <IconButton color='info' size='small' onClick={() => handleOpen(row?.awbNumber)}>
                  <UploadIcon fontSize='small' />
                </IconButton>
              </Tooltip>
            </Box>
          )
        } else {
          return (
            <Box sx={{display: 'flex', gap: 0.5, alignItems: 'center'}}>
              <Tooltip title='Status Log'>
                <IconButton size='small' varient='contained' onClick={() => handleOpenstatus(row)}>
                  <LocalLibraryIcon fontSize='small' />
                </IconButton>
              </Tooltip>
              <Tooltip title='Dispute'>
                <IconButton
                  color='button'
                  size='small'
                  onClick={() => handleOpenDispute(row?.awbNumber)}
                >
                  <SmsFailedIcon fontSize='small' />
                </IconButton>
              </Tooltip>
              <Tooltip title='Accept'>
                <IconButton
                  color='success'
                  size='small'
                  onClick={() => handleOpenAgree(row?.awbNumber)}
                >
                  <CheckCircleIcon fontSize='small' />
                </IconButton>
              </Tooltip>
              <Tooltip title='Upload Image'>
                <IconButton color='info' size='small' onClick={() => handleOpen(row?.awbNumber)}>
                  <UploadIcon fontSize='small' />
                </IconButton>
              </Tooltip>
            </Box>
          )
        }
      },
    },
  ]

  const handleOpen = (id) => {
    setOpen(true)
    setAwb(id)
  }
  const handleOpenDispute = (id) => {
    setDispute(true)
    setAwb(id)
    setStatus('DISPUTE')
  }
  const handleOpenAgree = (id) => {
    setAgree(true)
    setAwb(id)
    setStatus('ACCEPT')
  }

  const handleClose = () => {
    setOpen(false)
    setAgree(false)
    setDispute(false)
    setLog(false)
  }
  const handleOpenstatus = (id) => {
    setLog(true)
    setAwb(id)
  }

  const getDownloadInfo = () => {
    const formValues = methods.getValues()
    const filters = []

    if (formValues.awb) filters.push(`AWB: ${formValues.awb}`)
    if (formValues.status && formValues.status !== 'All') {
      const statusLabel =
        status.find((s) => s.value === formValues.status)?.label || formValues.status
      filters.push(`Status: ${statusLabel}`)
    }
    if (formValues.fromDate) filters.push(`From: ${formatDate(formValues.fromDate)}`)
    if (formValues.toDate) filters.push(`To: ${formatDate(formValues.toDate)}`)

    return filters.length > 0
      ? `Downloading data with ${filters.join(', ')}`
      : 'Downloading all data'
  }

  const downloadFile = (fileName) => {
    setLoading(true)
    count.skip = 0
    count.limit = 100000
    count.merchantId = merchantId
    count.statusIn = statusValue === 'All' ? '' : statusValue
    postGeneric(`${apiConstants.GET_WEIGHT_DICREPENACY}?download=true`, count)
      .then((res) => {
        if (res?.data?.reportMeta?.s3Link?.signedLink) {
          window.open(res?.data?.reportMeta?.s3Link?.signedLink)
        } else {
          const data = res?.data
          var blob = new Blob([data], {type: 'text/csv;charset=utf-8;'})
          let csvContent = URL.createObjectURL(blob)
          var encodedUri = encodeURI(csvContent)
          var link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          const eleId = `${fileName}`
          link.setAttribute('id', eleId)
          link.setAttribute('download', `${fileName}.csv`)
          document.body.appendChild(link)
          link.click()
          document.getElementById(eleId).remove()
        }
      })
      .catch((err) => {
        console.log(err)
        enqueueSnackbar('Something went wrong', {variant: 'error'})
      })
      .finally(() => setLoading(false))
  }

  return (
    <>
      {loading && <Loader />}
      <Box data-rp-filters sx={filterBarSx}>
        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}>
          <Typography sx={{fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: '14px', color: '#1B2A4A'}}>Weight Discrepancy</Typography>
          <Box sx={{display: 'flex', gap: 1}}>
            <Tooltip title={getDownloadInfo()}>
              <Button
                sx={primaryBtnSx}
                startIcon={<FileDownloadOutlined />}
                onClick={() => downloadFile('Weight_Discrepancy')}
                variant='contained'
              >
                Download
              </Button>
            </Tooltip>
            <Button
              variant='outlined'
              sx={secondaryBtnSx}
              startIcon={<UploadIcon />}
              onClick={() => {
                navigate('/weight-discrepancy-bulk-action')
              }}
            >
              Bulk Action Upload
            </Button>
          </Box>
        </Box>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={2}>
              <RHFTextField name='awb' label='AWB Number' size='small' />
            </Grid>
            <Grid item xs={12} md={2}>
              <RHFSelectField
                name='status'
                label='Select Status'
                size='small'
                options={status.map((op) => ({
                  label: op.label
                    .toLowerCase()
                    .replace(/(^\w| \w)/g, (match) => match.toUpperCase()),
                  value: op.value,
                }))}
                width='100%'
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <RHFDateRangePickerField
                name='created_date'
                label='Created Date'
                maxDate={new Date()}
                width='100%'
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{marginTop: 1}}>
              <Tooltip title={'Apply current filters to update the table data'}>
                <Button variant='contained' type='submit' sx={primaryBtnSx}>
                  Submit
                </Button>
              </Tooltip>
              <Button
                variant='outlined'
                sx={{...secondaryBtnSx, ml: 1}}
                onClick={() => {
                  reset({
                    awb: '',
                    merchant: '',
                    status: '',
                  })
                  setFilters({})
                  setSizePerPage(10)
                  setPage(0)
                  setReload(reload + 1)
                }}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </FormProvider>
      </Box>
      <ProzoDataGrid
        columns={columns}
        autoHeight={true}
        rows={list?.length > 0 ? list.map((val, index) => ({...val, id: index})) : []}
        sizePerPage={sizePerPage}
        setSizePerPage={setSizePerPage}
        setPage={setPage}
        page={page}
        pagination={true}
        hideFooterPagination={false}
        filterMode={'server'}
        // The filter API returns no total. -1 made the footer read "-9 - 0 of -1"; the shared helper
        // shows "of many" until a short page proves where the list ends.
        rowCount={lastPageRowCount({page, pageSize: sizePerPage, rowsOnPage: list?.length || 0, loading})}
        getRowId={(row) => row?.id}
        boxShadow={0}
      />
      <MUIModal
        open={open}
        handleClose={handleClose}
        children={<UploadImage id={awb} setReload={setReload} reload={reload} setOpen={setOpen} />}
        title={'Upload Image'}
        child={
          <Typography variant='body2' color='red'>
            File must be in .pdf, .png, .jpg, .jpeg format
          </Typography>
        }
      />
      <MUIModal
        open={dispute}
        handleClose={handleClose}
        children={
          <UpdateStatus id={awb} setReload={setReload} Status={Status} setOpen={setDispute} />
        }
        title={'Raise a dispute'}
      />
      <MUIModal
        open={agree}
        handleClose={handleClose}
        children={
          <UpdateStatus id={awb} setReload={setReload} Status={Status} setOpen={setAgree} />
        }
        title={'Accept Dispute'}
      />
      <MUIModal
        open={log}
        handleClose={handleClose}
        children={<StatusLog id={awb} />}
        title={'Status Log'}
        maxWidth='md'
      />
      <MUIModal
        open={viewImagesModal}
        handleClose={() => setViewImagesModal(false)}
        children={<ViewImages row={selectedImages} />}
        title={'View Images'}
        maxWidth='sm'
      />
    </>
  )
}

export default WeightDiscrepancyDetails
